require("../../sass/core.sass");

import { ApolloProvider } from "react-apollo";
import client from "../helpers/apollo-client";

import {
    Router,
    Route,
    browserHistory,
    useRouterHistory,
    createMemoryHistory,
    IndexRoute
} from "react-router";
let Provider = require("react-redux").Provider;
import React from "react";
import Homepage from "../components/nounproject-homepage";
import ForEdu from "../components/nounproject-for-edu";
import DownloadHistory from "../components/download-history";
import EduAuth from "./nounproject-edu-auth";
import EduBilling from "./edu-billing";
import EduApply from "../components/nounproject-edu-application";
import InvoiceList from "../components/invoice-list";
import InvoiceEdit from "../components/invoice-edit";
import IconDetail from "../containers/nounproject-icon-detail";
import { IconRow } from "../components/nounproject-iconlist-classic-row";

let Modal = require("./modal");
let NounContainer = require("./nounproject-container");

import store from "../stores/reduxStore";

class NounProject extends React.Component {
    constructor(props) {
        super(props);

        if (props.args) {
            window._nounConfig.args = props.args;
        }
    }

    render() {
        return (
            <ApolloProvider client={client}>
                <Provider store={store}>
                    <div style={{ width: "100%" }}>
                        <Router history={browserHistory}>
                            <Route path="/" component={NounContainer}>
                                <IndexRoute component={Homepage} />
                            </Route>
                            <Route path="/for-edu" component={NounContainer}>
                                <IndexRoute component={ForEdu} />
                            </Route>
                            <Route path="/for-edu/signup" component={EduAuth} />
                            <Route path="/for-edu/login" component={EduAuth} />
                            <Route path="/for-edu/apply" component={EduApply} />
                            <Route
                                path="/for-edu/billing"
                                component={EduBilling}
                            />
                            <Route
                                path="/:username/settings/invoices(/:chargeId)/edit"
                                component={InvoiceEdit}
                            />
                            <Route
                                path="/:username/settings/invoices(/:chargeId)/"
                                component={InvoiceList}
                            />
                            <Route
                                path="/:username/settings/invoices"
                                component={InvoiceList}
                            />
                            <Route
                                path="/:username/settings/icon-history"
                                component={DownloadHistory}
                            />
                            <Route
                                path="/icon/:iconId"
                                component={IconDetail}
                            />
                        </Router>
                        <Modal />
                    </div>
                </Provider>
            </ApolloProvider>
        );
    }
}

module.exports = NounProject;
